export default __webpack_public_path__ + "static/media/MCD.7c835edf.png";